import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";

const LogoutModal = ({ isOpen, onClose, onLogout, isLoading }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto"; // Cleanup on unmount
    };
  }, [isOpen]);

  if (!isOpen) return null;
  if (!isOpen) return null;
  return (
    <div>
      <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
        <div className="bg-white w-full max-w-lg p-6 rounded-lg relative shadow-lg">
          <button
            onClick={() => {
              onClose();
            }}
            className="absolute top-5 right-2 text-gray-500 hover:text-black"
          >
            <MdClose size={24} />
          </button>
          <h2 className="text-xl font-semibold mb-4">Logout?</h2>
          <p className="mt-5">Are you sure you want to log out?</p>

          <button
            onClick={() => {
              onLogout();
            }}
            className="btn btn-primary bg-[var(--primary-color)] w-full sm:w-36 mt-5 px-10 text-white rounded-full ml-auto block"
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Logout"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
